module.exports = __webpack_public_path__ + "img/vertical_6_6_9005.b5d84d7a.png";